<template>
  <el-select v-model="view" @change="toggle" placeholder="Select a View">
    <el-option v-for="(option, index) in options"
      :key="index"
      :label="option.text"
      :value="option.value">
    </el-option>
  </el-select>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    fields: null
  },
  data() {
    return {
      view: ['actions', 'status', 'transaction_type', 'primary_agent', 'full_address', 'active_date', 'expiration_date', 'days_on_market', 'contingent_sale', 'listing_price', 'gross_commission', 'source', 'team', 'gross_profit'],
      options:[
        { value: ['actions', 'status', 'transaction_type', 'primary_agent', 'full_address', 'active_date', 'expiration_date', 'days_on_market', 'contingent_sale', 'listing_price', 'gross_commission', 'source', 'team', 'gross_profit'], text: 'Standard View' },
        { value: ['actions', 'status', 'transaction_type', 'primary_agent', 'full_address', 'client_name', 'client_phone', 'client_email', 'close_date', 'listing_price', 'source', 'gross_commission'], text: 'Client Information' },
        { value: ['actions', 'status', 'transaction_type', 'primary_agent', 'full_address', 'listing_price', 'commission_type', 'transaction_fee', 'cos_details', 'gross_commission', 'gross_profit'], text: 'Financials' },
        { value: ['actions', 'status', 'transaction_type', 'primary_agent', 'full_address', 'mortgage_company', 'loan_officer', 'title_company', 'law_firm', 'escrow_officer', 'inspection_company', 'insurance_company'], text: 'Vendor Information' },
      ]
    }
  },
  methods: {
    toggle() {
      this.fields.filter((field) => {
        field.visible = false
      });

      this.view.forEach((value) => {
        this.fields.filter((field) => {
          if(field.key == value) {
            field.visible = !field.visible;
          }
        });
      });
    },
  }
};
</script>